module.exports = __webpack_public_path__ + "static/img/标定.20ee790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/support/标定.png
// module id = 7goQ
// module chunks = 0